import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import SliderAdapter from 'components/atoms/slider-adapter';

class FilterSlider extends Component {
    handleSliderChange(values) {
        const min = this.parseValue(values[0]);
        const max = this.parseValue(values[1]);

        const {mode} = this.props;
        this.props.dispatch(
            Action.set('InnerSalaryBoundary', {
                [mode]: {min, max},
            }),
        );
    }

    parseValue(value) {
        return parseFloat(value);
    }

    getValue(field) {
        const {boundary, mode} = this.props;
        return boundary.getInnerBoundary(field, mode);
    }

    render() {
        const {boundary, mode, step} = this.props;

        if (!boundary.hasBoundaries()) {
            return null;
        }

        const defaultMinVal = this.getValue('min');
        const defaultMaxVal = this.getValue('max');
        const minVal = boundary.getOuterMin(mode);
        const maxVal = boundary.getOuterMax(mode);

        return (
            <SliderAdapter
                key={`slider-${defaultMinVal}-${defaultMaxVal}`}
                onChange={::this.handleSliderChange}
                min={minVal}
                max={maxVal}
                defaultValue={[defaultMinVal, defaultMaxVal]}
                thumb={<div className="circle shifted"></div>}
                minDistance={step}
                step={step}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {salaryBoundary} = state;
    return {
        boundary: salaryBoundary,
    };
}

export default connect(mapStatesToProps)(FilterSlider);
